var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showFile)?_c('div',[_c(_vm.previewComponent,{key:_vm.path ? _vm.path : '',tag:"component",attrs:{"path":_vm.path,"name":_vm.name,"is-factor-table":_vm.isFactorTable,"max-width":_vm.maxWidth,"max-height":_vm.maxHeight}},[_vm._t("default")],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }